import React, { Component } from "react"
import TableDistratos from "./TableDistratos"
import * as ApiHelper from "../../ApiHelper"
import { Loading, HttpError } from "../../components"
import Layout from "../Layout"
export default class Distratos extends Component {
  constructor() {
    super()
    this.getDistratos = this.getDistratos.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { distratos: [], initialDistratos: [], showTable: false }
  }
  componentWillMount() {
    this.getDistratos()
  }
  getDistratos() {
    ApiHelper.getDistratos((distratos, error) => {
      if (distratos) {
        this.setState({
          distratos: distratos,
          initialDistratos: distratos,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  didDelete() {
    this.getDistratos()
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialDistratos.filter(distrato => {
      return (
        distrato.contrato.num_contrato.toLowerCase().search(searchText) !==
          -1 ||
        distrato.contrato.objeto.toLowerCase().search(searchText) !== -1 ||
        distrato.motivo.toLowerCase().search(searchText) !== -1 ||
        distrato.unidade_orcamentaria.uni_orc
          .toLowerCase()
          .search(searchText) !== -1
      )
    })
    this.setState({
      distratos: filtered
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscais de contrato">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Distratos">
        {this.state.showTable ? (
          <TableDistratos
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title="Distratos"
            subtitle="Listagem de distratos de contrato"
            backgroundColor="as-blue"
            rows={this.state.distratos}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/distratos/Distratos.js